import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, HostListener } from "@angular/core";
import { SymptommatrixService } from "./symptommatrix.service";
import { ContentManager } from '../modules/chatbot';

import * as d3 from "d3";

@Component({
    selector: 'app-symptom-matrix',
    templateUrl: "./symptommatrix.component.html",
    styleUrls: ["./symptommatrix.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SymptommatrixComponent implements OnInit {
    public chartDivId = "#chatbot-heatmap-chart";
    public chartTooltipId = "#chatbot-tooltip";

    @Input() content: ContentManager;
    @Input() params: any;


    public identifier: string = "";
    public viewType: string = "";

    public selectedIndication: string = "";
    public indicationList: any[] = [];
    public totalIndication: number = 0;
    public myHeatMapData: any[] = [];
    public allHeatMapData: any[] = [];

    public singleChartData: any[] = [];
    public heatMapChartData: any[] = [];
    public singleViewData: any[] = [];

    public tooltipData: any = {
        indication: "",
        symptom: "",
        percentage: ""
    }

    public showLoading: boolean = true;

    constructor(private cd: ChangeDetectorRef,
        private service: SymptommatrixService) { }

    ngOnInit(): void {
        if (this.isChatbotView) {
            this.identifier = this.params.symptommatrix;
            this.viewType = "single";
        } else {
            this.identifier = this.getParameterByName("identifier");
            this.viewType = this.getParameterByName("view");
            this.selectedIndication = this.getParameterByName("indication");
        }
        this.getChatBotHeatMapData();
    }

    get isChatbotView() {
        if (this.content && this.params) {
            return true;
        }
        return false;
    }

    get isSingleView() {
        if (this.viewType && this.viewType.toLowerCase() === "single") {
            return true;
        } else {
            return false;
        }
    }

    get isIdentifier() {
        if (this.identifier && this.identifier.length === 36) {
            return true;
        } else {
            return false;
        }
    }

    get openPageUrl() {
        var url = window.location.origin + "/symptommatrix";
        if (this.isSingleView) {
            url += "?view=matrix";
        } else {
            url += "?view=single";
        }
        if (this.isIdentifier) {
            url += "&identifier=" + this.identifier;
        }
        return url;
    }

    getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    //used for the chatbot
    wait() {
        return new Promise((resolve: any) => {
            resolve();
        });
    }

    openThePage() {
        var url = this.openPageUrl;
        window.open(url, "_parent");
    }


    getChatBotHeatMapData() {
        var query = this.isIdentifier ? "?identifier=" + this.identifier : "";
        this.service.getChatBotHeatMapData(query).subscribe({
            next: (res) => {
                this.showLoading = false;
                this.allHeatMapData = res?.All || [];
                this.myHeatMapData = res?.My || [];
                this.generateHeatMapChartData();
            },
            error: (err) => {
                this.showLoading = false;
            }
        })
    }

    generateHeatMapChartData() {
        this.singleChartData = [];
        this.heatMapChartData = [];
        var allSyms = [];

        this.allHeatMapData.sort(function (x, y) {
            return d3.descending(x.Symptoms.length, y.Symptoms.length);
        })

        for (var data of this.allHeatMapData) {
            var ind = data.Indication

            var symRecords = data.Symptoms;
            var ind_c = data.Count;

            var symGroups = d3.group(symRecords, function (d: any) { return d.symptom; });
            var sym_s = symGroups.size;
            for (var symGroup of symGroups) {
                var sym = symGroup[0]
                var sym_c = symGroup[1].length;

                var matched = false;
                if (this.isIdentifier) {
                    let objData = this.myHeatMapData.find(a => a.Indication === ind);
                    if (objData) {
                        let mySymRecords = objData.Symptoms;
                        matched = mySymRecords.findIndex(a => a.symptom === sym) >= 0 ? true : false;
                    }
                }

                this.singleChartData.push({ ind, ind_c, sym, sym_c, sym_s });
                this.heatMapChartData.push({ ind, ind_c, sym, sym_c, sym_s, matched });

                let index = allSyms.indexOf(sym);
                if (index < 0) {
                    allSyms.push(sym);
                }
            }
        }

        if (this.isSingleView) {
            this.singleChartData.sort(function (x, y) {
                return d3.descending(x.ind_c, y.ind_c);
            })
            this.setIndicationList();
        } else {
            ////Display rect for the records that are not pushed above
            for (var data of this.allHeatMapData) {
                ind = data.Indication;
                ind_c = 0;
                sym_s = 0;
                for (var sym of allSyms) {
                    var sym_c = 0;
                    let findInd = this.heatMapChartData.findIndex(a => a.ind === ind && a.sym === sym);
                    if (findInd < 0) {
                        this.heatMapChartData.push({ ind, ind_c, sym, sym_c, sym_s })
                    }
                }
            }
            this.heatMapChartData.sort(function (x, y) {
                return d3.descending(x.ind_c, y.ind_c);
            })
            this.renderHeatMapChart();
        }
    }

    setIndicationList() {
        this.indicationList = [];
        this.singleChartData.forEach(a => {
            if (this.indicationList.indexOf(a.ind) < 0) {
                this.indicationList.push(a.ind);
            }
        })
        if (this.indicationList.length) {
            if (!this.selectedIndication) {
                if (this.isIdentifier && this.myHeatMapData.length) {
                    let ind = this.myHeatMapData[0].Indication;
                    let index = this.indicationList.indexOf(ind);
                    index = index > 0 ? index : 0;
                    this.selectedIndication = this.indicationList[index];
                } else {
                    this.selectedIndication = this.indicationList[0];
                }
            }
            this.onChangeIndication();
        }
    }


    onChangeIndication() {
        this.singleViewData = [];
        let record = this.singleChartData.find(a => a.ind === this.selectedIndication);
        if (record) {
            this.totalIndication = record.ind_c;

            let records = this.singleChartData.filter(a => a.ind === this.selectedIndication);
            records.forEach(a => {
                var sym = a.sym
                var value = Math.round(100 * 100 * a.sym_c / a.ind_c) / 100; // calculate value
                var opacity = value / 100;
                var matched = false;

                if (this.isIdentifier) {
                    let objData = this.myHeatMapData.find(a => a.Indication === record.ind);
                    if (objData) {
                        let mySymRecords = objData.Symptoms;
                        matched = mySymRecords.findIndex(a => a.symptom === sym) >= 0 ? true : false;
                    }
                }
                if (opacity > 0) {
                    this.singleViewData.push({ name: sym, value, opacity, matched });
                }
            })
        }
        this.singleViewData.sort(function (x, y) {
            return d3.descending(x.value, y.value);
        })
    }

    renderHeatMapChart() {
        var component = this;
        d3.select(this.chartDivId).empty();
        if (!this.heatMapChartData.length) {
            d3.select(this.chartDivId).html("<h2>No chart data available</h2>")
            return;
        }

        // Labels of row and columns -> unique identifier of the column 
        var symGroup = d3.group(this.heatMapChartData, function (d: any) { return d.sym; });
        var indGroups = d3.group(this.heatMapChartData, function (d: any) { return d.ind; });

        var symLabels = [];
        var indLabels = [];

        for (var group of symGroup) {
            symLabels.push(group[0]);
        }
        for (var group of indGroups) {
            indLabels.push(group[0]);
        }
        symLabels = symLabels.reverse();

        var maxLSym = symLabels.length ? Math.max.apply(Math, $.map(symLabels, function (el) { return el.length })) : 0;
        var maxLInd = indLabels.length ? Math.max.apply(Math, $.map(indLabels, function (el) { return el.length })) : 0

        var right = 20;
        if (indLabels.length) {
            var start = indLabels.length > 3 ? indLabels.length - 3 : 0;
            var end = indLabels.length;
            var last3Labels = indLabels.slice(start, end);
            var maxLen = Math.max.apply(Math, $.map(last3Labels, function (el) { return el.length }))
            let extra = maxLen * 4.2;
            right += extra;
        }


        // chart dimensions
        var margin = {
            top: maxLInd * 6,
            right: right,
            bottom: 120,
            left: maxLSym * 7.2
        };
        let nodeElemet: any = d3.select(this.chartDivId).node();
        let elementRect = nodeElemet.getBoundingClientRect();
        let width = elementRect.width - margin.left - margin.right;
        let height = (symLabels.length * 35);
        let minWidth = indLabels.length * 55;

        height = height < 200 ? 200 : height;
        minWidth = minWidth < 300 ? 300 : minWidth;

        let indWidths = indLabels.length * 100;
        if (indWidths < width) {
            width = indWidths;
        }
        if (width < minWidth) {
            width = minWidth;
        }

        let fullWidth = width + margin.left + margin.right;
        let fullHeight = height + margin.top + margin.bottom;

        d3.select(this.chartDivId).selectAll("*").remove();
        let svg = d3.select(this.chartDivId) // select element in the DOM with chartDiv
            .append('svg') // append an svg element to the element we've selected
            .attr('width', fullWidth) // set the width of the svg element we just added
            .attr('height', fullHeight) // set the height of the svg element we just added
            .attr("fill", "#ddd")
            .append('g') // append 'g' element to the svg element
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // our reference is now to the 'g' element. centerting the 'g' element to the svg element

        // Build X scales and axis:
        var xTop = d3.scaleBand().range([0, width]).domain(indLabels).padding(0.08);
        var xTopGridlines = d3.axisTop(xTop).tickSize(0);
        var xTopGrid = svg.append("g")
            .attr("class", "x-top")
            .attr("transform", "translate(0,0)")
            .call(xTopGridlines);
        xTopGrid.selectAll("text")
            .attr("transform", "translate(12,0)rotate(-45)")
            .style("text-anchor", "start")
            .attr("class", "link")
            .on("click", function (d, label) {
                var url = window.location.origin + "/symptommatrix?view=single&indication=" + label;
                window.open(url, "_parent");
            });
        xTopGrid
            .selectAll(".tick")
            .append("line")
            .attr("stroke", "currentColor")
            .attr("y2", "-" + margin.top + 100)
            .attr("transform", "translate(" + ((xTop.bandwidth() / 2) + 3) + ",0)rotate(45)");

        var xBottom = d3.scaleBand().range([0, width]).domain(indLabels).padding(0.08);
        var xBottomGridlines = d3.axisBottom(xBottom).tickFormat((d) => { return ''; }).tickSize(0);
        svg.append("g").attr("class", "x-bottom").attr("transform", "translate(0," + height + ")").call(xBottomGridlines);

        // Build Y scales and axis:
        var yLeft = d3.scaleBand().range([height, 0]).domain(symLabels).padding(0.08);
        var yLeftGridlines = d3.axisLeft(yLeft).tickSize(0);
        var yLeftGrid = svg.append("g").attr("class", "y-left").attr("transform", "translate(0,0)").call(yLeftGridlines);
        yLeftGrid
            .selectAll(".tick")
            .append("line")
            .attr("stroke", "currentColor")
            .attr("x2", "-" + margin.left)
            .attr("transform", "translate(0," + ((yLeft.bandwidth() / 2) + 3) + ")");

        var yRight = d3.scaleBand().range([height, 0]).domain(symLabels).padding(0.08);
        var yRightGridlines = d3.axisRight(yRight).tickFormat((d) => { return ''; }).tickSize(0);
        svg.append("g").attr("class", "y-right").attr("transform", "translate(" + width + ",0)").call(yRightGridlines);


        // Build color scale
        var colorCodes = ["#f4fafc", "#c7e7fc", "#7bc5ff", "#76c0ff", "#39a7fc", "#0087ff"];
        var legendData = [
            { offset: "0%", color: colorCodes[0] },
            { offset: "20%", color: colorCodes[1] },
            { offset: "40%", color: colorCodes[2] },
            { offset: "60%", color: colorCodes[3] },
            { offset: "80%", color: colorCodes[4] },
            { offset: "100%", color: colorCodes[5] },
        ]

        var color = d3.scaleLinear<string>()
            .domain([0, 20, 40, 60, 80, 100])
            .range(colorCodes)
            .interpolate(d3.interpolateHcl);


        // add the squares
        let rect = svg.selectAll()
            .data(this.heatMapChartData, function (d: any) { return d.ind + ':' + d.sym; })
            .enter()
            .append("rect")
            .attr("class", "rect-cell")
            .attr("x", function (d: any) { return xTop(d.ind) })
            .attr("y", function (d: any) { return yLeft(d.sym) })
            .attr("rx", function (d: any) {
                if (d.ind_c > 0) {
                    return 2;
                }
                return 0;
            })
            .attr("ry", function (d: any) {
                if (d.ind_c > 0) {
                    return 2;
                }
                return 0;
            })
            .attr("width", xTop.bandwidth())
            .attr("height", yLeft.bandwidth())
            .style("cursor", function (d: any) {
                if (d.sym_c > 0) {
                    return "pointer";
                }
                return "inherit";
            })
            .style("stroke-width", 2)
            .style("stroke", function (d: any) {
                if (d.matched) {
                    return "#000"
                } else {
                    if (d.ind_c > 0) {
                        var value = Math.round(100 * 100 * d.sym_c / d.ind_c) / 100; // calculate value
                        return color(value)
                    }
                    return color(0);
                }
            })
            .style("fill", function (d: any) {
                if (d.ind_c > 0) {
                    var value = Math.round(100 * 100 * d.sym_c / d.ind_c) / 100; // calculate value
                    return color(value)
                }
                return color(0);
            });

        let barW = xTop.bandwidth();
        let barH = yLeft.bandwidth();

        var bar = svg
            .selectAll(".rect-values")
            .data(this.heatMapChartData)
            .enter()
            .append("g")
            .attr("class", "rect-value")
            .attr("transform", "translate(" + (barW / 2) + "," + (barH / 2) + ")");

        bar
            .append("text")
            .attr("x", (d) => xTop(d.ind))
            .attr("y", (d) => yLeft(d.sym))
            .attr("fill", "#000")
            .text((d) => {
                if (d.ind_c > 0) {
                    var value = Math.round(100 * 100 * d.sym_c / d.ind_c) / 100; // calculate value
                    return value > 0 ? value + "%" : "";
                }
                return "";
            });



        // define tooltip
        let tooltip = d3.select(this.chartTooltipId);

        // mouse event handlers are attached to bar so they need to come after its definition
        rect.on('mouseover', function (event, d) { // when mouse enters div      
            if (d.ind_c > 0) {
                var value = Math.round(100 * 100 * d.sym_c / d.ind_c) / 100; // calculate value
                component.tooltipData.indication = d.ind;
                component.tooltipData.symptom = d.sym;
                component.tooltipData.percentage = value + "%";
                tooltip.style('display', 'block'); // set display                    
            }
        });

        rect.on('mouseout', function () { // when mouse leaves div                        
            tooltip.style('display', 'none'); // hide tooltip for that element
        });

        rect.on('mousemove', function (event) { // when mouse moves        
            var top = event.layerY + 10;
            var left = event.layerX + 10;
            if (left + 180 > window.outerWidth) {
                left = left - 180;
            }
            tooltip.style('top', top + 'px') // always 10px below the cursor
                .style('left', left + 'px'); // always 10px to the right of the mouse
        });


        // ! Creating the legend
        var linearGradient = svg
            .append("linearGradient")
            .attr("id", "linear-gradient");
        //Horizontal gradient
        linearGradient
            .attr("x1", "0%")
            .attr("y1", "0%")
            .attr("x2", "100%")
            .attr("y2", "0%");
        //Append multiple color stops by using D3's data/enter step
        linearGradient
            .selectAll("stop")
            .data(legendData)
            .enter()
            .append("stop")
            .attr("offset", function (d) { return d.offset; })
            .attr("stop-color", function (d) { return d.color; });


        var legendWidth = width * 0.5,
            legendHeight = 8;

        //Color Legend container
        var legendsvg = svg
            .append("g")
            .attr("id", "legend")
            .attr(
                "transform",
                "translate(" + legendWidth / 2 + "," + (height + 50) + ")"
            );
        //Draw the Rectangle
        legendsvg
            .append("rect")
            .attr("class", "legendRect")
            .attr("x", 0)
            .attr("y", 10)
            .attr("width", legendWidth)
            .attr("height", legendHeight)
            .style("fill", "url(#linear-gradient)")
            .style("stroke", "black")
            .style("stroke-width", "1px");

        //Set scale for x-axis
        var xScale2 = d3
            .scaleLinear()
            .range([0, legendWidth])
            .domain([0, 100]);

        legendsvg
            .append("g")
            .call(
                d3
                    .axisBottom(xScale2)
                    .tickValues([0, 20, 40, 60, 80, 100])
                    .tickFormat((x) => x + "%")
            )
            .attr("class", "legendAxis")
            .attr("id", "legendAxis")
            .attr(
                "transform",
                "translate(0," + (10 + legendHeight) + ")"
            );
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (!(this.isSingleView && this.isChatbotView)) {
            if (d3.select(this.chartDivId) && d3.select(this.chartDivId).exit()) {
                this.renderHeatMapChart();
            }
        }
    }
}
